import { render } from "./UserList.vue?vue&type=template&id=765edc9b"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Allgemein\\Ich\\Hobbys\\Programmieren\\Web Development\\little-projects\\vue-test-router\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__